<app-header></app-header>
<bit-container>
  @if (loading()) {
    <bit-spinner />
  } @else {
    @if (provider(); as provider) {
      <form [formGroup]="formGroup" [bitSubmit]="submit">
        <div class="tw-grid tw-grid-cols-12 tw-gap-4">
          <div class="tw-col-span-6">
            <bit-form-field>
              <bit-label>{{ "providerName" | i18n }}</bit-label>
              <input
                id="provider-account_input_name"
                bitInput
                type="text"
                formControlName="providerName"
              />
            </bit-form-field>
            <bit-form-field>
              <bit-label>{{ "billingEmail" | i18n }}</bit-label>
              <input
                id="provider-account_input_billing-email"
                bitInput
                type="text"
                formControlName="providerBillingEmail"
              />
            </bit-form-field>
          </div>
          <div class="tw-col-span-6">
            <bit-avatar [text]="provider.name" [id]="provider.id" size="2xl"></bit-avatar>
          </div>
        </div>
        <button
          id="provider-account_button_save"
          type="submit"
          bitFormButton
          bitButton
          buttonType="primary"
        >
          {{ "save" | i18n }}
        </button>
      </form>

      <app-danger-zone>
        <button
          id="provider-account_button_delete"
          type="button"
          bitButton
          buttonType="danger"
          (click)="deleteProvider(provider)"
        >
          {{ "deleteProvider" | i18n }}
        </button>
      </app-danger-zone>
    }
  }
</bit-container>
